// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9c7f287e","239":"dd1decc1","365":"b6cd6621","453":"9b46f5db","455":"00166b8d"}[chunkId] + ".chunk.js";
};